module.exports = __webpack_public_path__ + "fonts/db_helvethaicaais_x_med_v3.2-webfont.85f37d50.eot";